import PropTypes from 'prop-types';
import { Typography, Box, Accordion, AccordionSummary } from '@mui/material';
import { ArrowDownward } from '@mui/icons-material';

AccordionWrapper.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  defaultExpanded: PropTypes.bool,
  unmountOnExit: PropTypes.bool,
}

export default function AccordionWrapper({ title, children, defaultExpanded = false, unmountOnExit = false }) {

  return <Box sx={{ border: "solid thin rgb(43 45 47 / 24%)" }}>
    <Accordion disableGutters defaultExpanded={defaultExpanded} slotProps={{ transition: { unmountOnExit } }} >
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Typography component="span">{title}</Typography>
      </AccordionSummary>
      <Box sx={{ mx: 2, mb: 2 }}>
        {children}
      </Box>
    </Accordion>
  </Box>;
}
